<p>dialog-edit-note works!</p>
